export type NativePromoOrigin =
  | 'purchase'
  | 'home_icon'
  | 'gem_shop_icon'
  | 'gem_plus_button'
  | 'launch'
  | 'low_gem_balance'
  | 'match2_pregame'
  | 'match2_bundle_sale'
  | 'bpoints_from_puzzle';

// both ios and android app
export const nativeAppLaunchUrl = 'co.play.buruburu://main';
export const googlePlayURL =
  'https://play.google.com/store/apps/details?id=co.play.buruburu';
export const appStoreURL =
  'https://apps.apple.com/us/app/ぶるぶるどーぶつ/id1638675792';
// Reward for installing native app
export const appInstallReward = { gems: 200 };

// Reward for updating native app (incentivised update)
export const appUpdateReward = { gems: 200 };

/**
 * Configuration for native app version update checks.
 *
 * @property allowedVersions - Strict allowlist of versions that skip update prompts.
 *   Any version not in this list (including newer or malformed) triggers a hard update.
 *   Takes precedence over soft/hard thresholds when configured.
 * @property soft - Minimum version for soft update prompt (semantic comparison).
 * @property hard - Minimum version for hard update prompt (semantic comparison).
 */
type PlatformVersionUpdate = {
  allowedVersions?: string[];
  soft?: string;
  hard?: string;
};

type VersionUpdate = {
  android: PlatformVersionUpdate;
  ios: PlatformVersionUpdate;
};

export const versionUpdateConfig: VersionUpdate = {
  android: {},
  ios: {},
};

/**
 * Inactivity threshold (in days) for determining native app usage status.
 * If a user has not launched the native app within this period, they are
 * considered inactive on native and may be migrated to the MiniApp experience.
 * Used in guessIsNativeAppInstalled().
 */
export const NATIVE_MIGRATION_OPTIONAL_WINDOW = 30;
